import React from 'react'
import Banner from '../Components/Banner';
import BannerImage from "../Images/service-banner.jpg";
import ContactSection from '../Components/ContactSection';
import Ser1 from "../Images/services/Weddings.jpg";
import Ser2 from "../Images/services/Corporate Events.jpg";
import Ser3 from "../Images/services/Social Gathering.jpg";
import Ser4 from "../Images/services/Birthdays.jpg";
import Ser5 from "../Images/services/Cocktail Party.jpg";
import Ser6 from "../Images/services/House Warming.jpg";
import Ser7 from "../Images/services/Half Saree.jpg";
import Ser8 from "../Images/services/Dhothi Ceremony.jpg";
import { Col, Container, Row, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const Services = () => {
  const bannerTitle = (
    <>
      Services
    </>
  );
  const bannerContent = "";
  const bannerConclude = "";
  const serviceData = [
    {
      id: 1,
      title: 'Weddings',
      image: Ser1,
      description: 'Weddings',
      link: '/services/weddings'
    },
    {
      id: 2,
      title: 'Corporate Events',
      image: Ser2,
      description: 'Corporate Events',
      link: '/services/corporate-events'
    },
    {
      id: 3,
      title: 'Social Gathering',
      image: Ser3,
      description: 'Social Gathering',
      link: ''
    },
    {
      id: 4,
      title: 'Birthday Party',
      image: Ser4,
      description: 'Birthday Party',
      link: ''
    },
    {
      id: 5,
      title: 'Cocktail Party',
      image: Ser5,
      description: 'Cocktail Party',
      link: ''
    },
    {
      id: 6,
      title: 'House Warming Ceremony',
      image: Ser6,
      description: 'House Warming Ceremony',
      link: ''
    },
    {
      id: 7,
      title: 'HalfSaree Ceremony',
      image: Ser7,
      description: 'HalfSaree Ceremony',
      link: ''
    },
    {
      id: 8,
      title: 'Dhothi Ceremony',
      image: Ser8,
      description: 'Dhothi Ceremony',
      link: ''
    }
  ];
  
  return (
    <div className='home-content'>
      <Banner image={BannerImage} propAlt={"Home Banner"} 
          bannerTitle={bannerTitle} bannerContent={bannerContent} bannerConclude={bannerConclude} />
      <section className="services-section py-5">
          <Container>
            
            <h2 className="text-center mb-5">Elegant Dining Experiences in</h2>
            
            <Row className="g-4">
              {serviceData.map((service, index) => (
                <Col key={service.id} xs={12} sm={6} md={4} lg={3}>
                  <Card className={`service-card h-100 ${((index + 1) % 2 === 0) ? 'mt-5' : ''}`}>
                    <div className="card-img-wrapper">
                      <Card.Img variant="top" src={service.image} alt={service.title} />
                    </div>
                    <Card.Body>
                      <Card.Title>
                        {service.link && service.link !== "" ? (
                          <Link
                          to={service.link}
                          className="stretched-link text-decoration-none text-dark d-flex align-items-center justify-content-center gap-3"
                        >
                          {service.title} <FontAwesomeIcon icon={faAngleDoubleRight} />
                        </Link>

                        ) : (
                          <div className="stretched-link text-decoration-none text-dark">
                            {service.title}
                          </div>
                        )}
                      </Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </section>
        <ContactSection />
    </div>
  )
}

export default Services